import { render } from "./backend-errors.vue?vue&type=template&id=26ae5b2a"
import script from "./backend-errors.vue?vue&type=script&lang=js"
export * from "./backend-errors.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_b6f5290c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__